import axios from 'axios';
import * as types from '../constants/ActionTypes';

const suggestionsCache = {};

const resetSuggestions = () => ({
  type: types.RESET_SUGGESTIONS,
  payload: {},
});

const showSuggestions = () => ({
  type: types.SHOW_SUGGESTIONS,
  payload: {},
});

function requestSuggestions(text) {
  return {
    type: types.REQUEST_SUGGESTIONS,
    payload: { text },
  };
}

function receiveSuggestions(query, autoComplete) {
  return {
    type: types.RECEIVE_SUGGESTIONS,
    payload: { query, autoComplete },
  };
}

function receiveSuggestionsError() {
  return {
    type: types.RECEIVE_SUGGESTIONS_ERROR,
  };
}

function updateSuggestionsFromCache(query, autoComplete) {
  return {
    type: types.UPDATE_SUGGESTIONS_FROM_CACHE,
    payload: { query, autoComplete },
  };
}

function getSuggestions(query) {
  return (dispatch) => {
    dispatch(requestSuggestions(query));
    return axios.get(`/smarthelp/auto-complete?q=${query}`)
      .then((response) => {
        const { autoComplete } = response.data;
        if (autoComplete.length) {
          suggestionsCache[query] = autoComplete; // update the cache
        }

        dispatch(receiveSuggestions(query, autoComplete));
      })
      .catch(() => dispatch(receiveSuggestionsError()));
  };
}

export const clearSuggestions = () => (dispatch) => {
  dispatch(resetSuggestions());
};

export const enableSuggestions = () => (dispatch) => {
  dispatch(showSuggestions());
};

export default function updateSuggestions(query) {
  return (dispatch) => {
    if (query in suggestionsCache) {
      dispatch(updateSuggestionsFromCache(query, suggestionsCache[query]));
    } else {
      dispatch(getSuggestions(query));
    }
  };
}
